<template>
  <div class="workflow-schedule">
    <div>
      <div>
        <workflow-schedule></workflow-schedule>
      </div>
    </div>
  </div>
</template>

<script>
import Schedule from '@/components/workflow/Schedule.vue'
import { DataState, AppState, AppKind } from '@/state'
export default {
  name: 'WorkflowCricketSchedule',
  components: {
    'WorkflowSchedule': Schedule
  },
  // mounted () {
  //    if (this.$route.path.indexOf('/workflow') > -1) {
  //     AppState.updateAppKind(AppKind.Workflow)
  //   }
  // }
}
</script>
